export const initialValues = {
    personDocuments: {
        front: [],
        back: [],
    },
};

export const maxDocumentSize = 10 * 1024 * 1024;
